import { FtlRoutingViewModel } from "../../ViewModel/FtlRoutingViewModel";
import { PuDo } from "../../ViewModel/PuDo";
import { RoutingType } from "../../ViewModel/RoutingType";

// Order route stops by "weight", then by previous index.
// This way, the order of existing stops is preserved,
// while newly added stops are appended to the end of their respective "groups" in the routing table.
export const sortRoutingTable = (routingTable: Array<FtlRoutingViewModel>) =>
  (routingTable ?? [])
    .map((it, index) => ({
      ...it,
      previousIndex: index,
    }))
    .sort((a, b) => {
      const weightDiff = weightOf(a) - weightOf(b);
      return weightDiff !== 0 ? weightDiff : a.previousIndex - b.previousIndex;
    });

const weightOf = (x: FtlRoutingViewModel) => {
  if (x.PuDoType === PuDo.PU_I) {
    return 0;
  }
  if (x.PuDoType === PuDo["-"] && x.RoutingType !== RoutingType.ODC) {
    return 4;
  }
  if (x.PuDoType === PuDo.DO_I) {
    return 5;
  }
  if (x.PuDoType === PuDo.PU_R) {
    return 10;
  }
  if (x.PuDoType === PuDo.DO_R) {
    return 15;
  }
  if (x.PuDoType === PuDo["-"] && x.RoutingType === RoutingType.ODC) {
    return 20;
  }

  throw Error(`getWeight not implemented for PuDoType ${x.PuDoType} RoutingType ${x.RoutingType}`);
};
